import EndTreatmentGroupModal from './EndTreatmentGroupModal';

export default EndTreatmentGroupModal;
